import { HStack, Text, Button, Input, Select, Popover, Portal, createListCollection, Dialog, CloseButton } from "@chakra-ui/react";
import { LuListFilter, LuSearch, LuX, LuCombine, LuEye, LuEyeOff, LuArrowDownAZ, LuArrowUpAZ, LuTrash, LuSquareDashedMousePointer, LuFilter } from "react-icons/lu";
import { Tooltip } from "../../../../ui/tooltip";
import HoPolygonInvisible from "../../../../../icons/HoPolygonInvisible";
import { useAppStore } from "../../../../../context/store";
import Type from "../../../../../utilies/Types";
import { bboxCornersLonLatArrays, createGeoJSONFile, matchKeyInText, removeEpochSuffix, removeFileExtension, showToast, sortList } from "../../../../../utilies/Utility";
import { deleteAsset } from "../../../../../utilies/GeojsonUtility";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
import { useEffect, useRef, useState } from "react";
import { selectEntitiesInRectangleOnce } from "../../../../../utilies/other/GetEntitiesInBounds";
import { diffGeoJSON } from "../../../../../utilies/geojson/GetDiffrentGeojson";
import { serviceSaveLayer } from "../../../../../api/services/layer";

const SelectProject = ({ state }) => {
  const { mapObjects, setMapObjects } = useMapObjects();
  const projects = useAppStore((s) => s.projects);
  const userData = useAppStore((s) => s.userData);

  const [selectedProjectLocal, setSelectedProjectLocal] = useState(null);

  // Merge two GeoJSON FeatureCollections and re-id features of geojsonB
  function mergeGeojsonWithReId(geojsonA, geojsonB) {
    const a = geojsonA?.type === "FeatureCollection" ? geojsonA : { type: "FeatureCollection", features: [] };
    const b = geojsonB?.type === "FeatureCollection" ? geojsonB : { type: "FeatureCollection", features: [] };

    const aFeatures = Array.isArray(a.features) ? a.features : [];
    const bFeatures = Array.isArray(b.features) ? b.features : [];

    const maxIdInA = aFeatures.reduce((max, f) => {
      const raw = f?.properties?.id;
      const n = typeof raw === "number" ? raw : Number.parseInt(raw, 10);
      return Number.isFinite(n) ? Math.max(max, n) : max;
    }, -1);

    let nextId = maxIdInA + 2;

    const bReId = bFeatures.map((f) => {
      const cloned = typeof structuredClone === "function" ? structuredClone(f) : JSON.parse(JSON.stringify(f));
      cloned.type = "Feature";
      cloned.properties = { ...(cloned.properties || {}), id: nextId };
      nextId += 2;
      return cloned;
    });

    return {
      type: "FeatureCollection",
      features: [...aFeatures, ...bReId],
    };
  }

  const copy = () => {
    let projectId = selectedProjectLocal;
    let out = state[0];
    for (const key in projects) {
      if (projects[key].id != projectId) continue;

      for (const key2 in projects[key].layers) {
        let layer = projects[key].layers[key2];
        let projectLayerName = layer.layer_name;

        for (const key3 in out) {
          if (matchKeyInText(removeEpochSuffix(removeFileExtension(projectLayerName)), removeEpochSuffix(removeFileExtension(out[key3].layerName)))) {
            fetch(layer.file_url)
              .then((response) => {
                if (!response.ok) {
                }
                return response.json();
              })
              .then((data) => {
                const merged = mergeGeojsonWithReId(data, out[key3].geojson);

                const formData = new FormData();

                const geojson = merged;

                // --- Proceed only if we have features ---
                const file = createGeoJSONFile(geojson, removeEpochSuffix(removeFileExtension(projectLayerName)).toUpperCase());

                const bbox = bboxCornersLonLatArrays(geojson);

                let changeset = diffGeoJSON(data, geojson);

                formData.append("file", file);
                formData.append(
                  "data",
                  JSON.stringify({
                    layer_name: removeFileExtension(layer.layer_name),
                    layer_style: layer.style,
                    layer_type: layer.layer_type,
                    geometry_type: layer.geometry_type,
                    description: layer.description,
                    username: userData.user.username,
                    bbox: JSON.stringify(bbox),
                    changeset: JSON.stringify(changeset),
                  }),
                );
                formData.append("layer_id", layer.id);

                serviceSaveLayer(formData)
                  .then((res) => {
                    if (res.data.status == "failed") {
                      showToast(res.data.message, Type.NOTIFICATION.ERROR);
                    } else {
                      showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
                    }
                  })
                  .catch((err) => {
                    console.error("Error", err);
                    showToast("Saving failed due to an unexpected error.", Type.NOTIFICATION.ERROR);
                  });
              })
              .catch((error) => {
                console.error(error);
              });
            break;
          }
        }
        state[1](null);
      }
    }
  };

  const [projectList, setProjectList] = useState(
    createListCollection({
      items: [],
    }),
  );
  useEffect(() => {
    if (state[0]) {
      let temp = [];
      for (const key in projects) {
        temp.push({ label: projects[key].project_name, value: projects[key].id });
      }
      setProjectList(
        createListCollection({
          items: temp,
        }),
      );
    }
  }, [state[0]]);
  return (
    <Dialog.Root
      lazyMount
      open={state[0]}
      onOpenChange={(e) => {
        if (!e.open) {
          state[1](null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> Select Porject </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Select.Root
                collection={projectList}
                size="sm"
                width="full"
                onValueChange={(v) => {
                  setSelectedProjectLocal(v.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder="" />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {projectList.items.map((sl) => (
                      <Select.Item item={sl} key={sl.value}>
                        {sl.label}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                onClick={() => {
                  copy();
                }}
              >
                Copy
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

const LayerSortAndSearchBar = ({ filterType, setFilterType, layerSearch, setLayerSearch, isAZ, setIsAZ, isShowAllLayers, setIsShowAllLayers, invisibleAllPolygon, selectedObjectsForDeleteState }) => {
  const userType = useAppStore((s) => s.userType);
  const projects = useAppStore((s) => s.projects);
  const userData = useAppStore((s) => s.userData);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const setFilterGeojsonOnAllDialog = useAppStore.getState().setFilterGeojsonOnAllDialog;

  const viewerRef = useAppStore.getState().viewerRef;
  const { mapObjects, setMapObjects } = useMapObjects();

  const originalCameraControls = useAppStore.getState().originalCameraControls;
  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const setCamera = useAppStore.getState().setCamera;
  const setIsShowMergeDialog = useAppStore((s) => s.setIsShowMergeDialog);

  const [isSelecting, setIsSelecting] = useState(false);
  const selectionCancelRef = useRef(null);

  const [showSelectProjectDialog, setShowSelectProjectDialog] = useState(null);

  const toggleSelection = () => {
    let projectId = null;
    if (isSelecting) {
      selectionCancelRef.current?.();
      selectionCancelRef.current = null;
      setIsSelecting(false);

      showToast("Selection tool disabled", Type.NOTIFICATION.INFO);

      return;
    }

    const { promise, cancel } = selectEntitiesInRectangleOnce(viewerRef.current, mapObjects, originalCameraControls, { onActiveChange: setIsSelecting });

    selectionCancelRef.current = cancel;

    showToast("Selection tool enabled", Type.NOTIFICATION.INFO);

    promise
      .then((out) => {
        showToast("Selection completed", Type.NOTIFICATION.INFO);

        setShowSelectProjectDialog(out);
      })
      .catch((err) => {
        console.error("Selection error:", err);
        showToast("Selection failed", Type.NOTIFICATION.INFO);
      })
      .finally(() => {
        selectionCancelRef.current = null;
        setIsSelecting(false);
        showToast("Selection tool disabled", Type.NOTIFICATION.INFO);
      });
  };

  return (
    <>
      <HStack width="full" justify="space-between" bg="blackAlpha.100" p={1} py={0} borderRadius="lg">
        <HStack gap={1}>
          <LuListFilter size={18} />
          <Text fontWeight="bold" fontSize="13px">
            Sort:
          </Text>
          <Select.Root
            collection={sortList}
            size="sm"
            width="100px"
            value={[filterType]}
            onValueChange={(v) => {
              setFilterType(v.value[0]);
            }}
          >
            <Select.HiddenSelect />
            <Select.Control>
              <Select.Trigger outline={"none"} border={"none"} borderWidth={"0px"}>
                <Select.ValueText placeholder="" />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Select.Positioner>
              <Select.Content>
                {sortList.items.map((sl) => (
                  <Select.Item item={sl} key={sl.value}>
                    {sl.label}
                    <Select.ItemIndicator />
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Positioner>
          </Select.Root>
        </HStack>

        <HStack gap={2}>
          <Popover.Root>
            <Popover.Trigger asChild>
              <Button background="transparent" p={0}>
                <Tooltip content="Search">
                  <LuSearch size={20} color="MenuText" />
                </Tooltip>
              </Button>
            </Popover.Trigger>
            <Portal>
              <Popover.Positioner>
                <Popover.Content>
                  <Popover.Arrow />
                  <Popover.Body p={2}>
                    <Text mb={1}>Search between layers</Text>
                    <Input
                      placeholder="Search ..."
                      value={layerSearch}
                      onChange={(v) => {
                        setLayerSearch(v.target.value);
                      }}
                    />
                    {layerSearch && (
                      <Button
                        onClick={() => {
                          setLayerSearch("");
                        }}
                        position="absolute"
                        top={5}
                        right={3}
                        background="transparent"
                        color="MenuText"
                      >
                        <LuX />
                      </Button>
                    )}
                  </Popover.Body>
                </Popover.Content>
              </Popover.Positioner>
            </Portal>
          </Popover.Root>

          {selectedProject && (userType.includes(Type.ROLE.SUPER_ADMIN) || userType.includes(Type.ROLE.ANNOTATOR) || userType.includes(Type.ROLE.DIGITIZER) || userType.includes(Type.ROLE.ADMIN)) ? (
            <Button
              variant="ghost"
              p={0}
              minW="unset"
              h="auto"
              bg={isSelecting ? "green.100" : "transparent"}
              onClick={() => {
                toggleSelection();
              }}
            >
              <Tooltip content="Selection to copy to project">
                <LuSquareDashedMousePointer size={20} color={isSelecting ? "green" : "MenuText"} />
              </Tooltip>
            </Button>
          ) : null}

          <Button
            variant="ghost"
            p={0}
            minW="unset"
            h="auto"
            bg="transparent"
            onClick={() => {
              setFilterGeojsonOnAllDialog(true);
            }}
          >
            <Tooltip content="Filter">
              <LuFilter size={20} color="MenuText" />
            </Tooltip>
          </Button>

          {(userType.includes(Type.ROLE.ANNOTATOR) || userType.includes(Type.ROLE.DIGITIZER) || userType.includes(Type.ROLE.ADMIN) || userType.includes(Type.ROLE.SUPER_ADMIN)) &&
            selectedObjectsForDeleteState[0].length != 0 && (
              <Button
                disabled={selectedObjectsForDeleteState[0].length == 0}
                display="contents"
                background="transparent"
                p={0}
                onClick={() => {
                  for (const key in selectedObjectsForDeleteState[0]) {
                    for (const key2 in mapObjects) {
                      if (mapObjects[key2].id == selectedObjectsForDeleteState[0][key]) {
                        deleteAsset(viewerRef.current, mapObjects[key2], [mapObjects, setMapObjects], setImageGeojsonMode, setCamera);
                        break;
                      }
                    }
                  }
                }}
              >
                <Tooltip content="Remove Layers">
                  <LuTrash size={20} color="red" />
                </Tooltip>
              </Button>
            )}
          {(userType.includes(Type.ROLE.ANNOTATOR) || userType.includes(Type.ROLE.DIGITIZER) || userType.includes(Type.ROLE.ADMIN) || userType.includes(Type.ROLE.SUPER_ADMIN)) && (
            <Button
              display="contents"
              background="transparent"
              p={0}
              onClick={() => {
                setIsShowMergeDialog(true);
              }}
            >
              <Tooltip content="Merge Layers">
                <LuCombine size={20} color="MenuText" />
              </Tooltip>
            </Button>
          )}

          <Button
            display="contents"
            background="transparent"
            p={0}
            onClick={() => {
              invisibleAllPolygon();
            }}
          >
            <Tooltip content="Hide Polygons">
              <HoPolygonInvisible size={20} color="MenuText" />
            </Tooltip>
          </Button>

          <Button
            display="contents"
            background="transparent"
            p={0}
            onClick={() => {
              setIsShowAllLayers(!isShowAllLayers);
            }}
          >
            <Tooltip content={isShowAllLayers ? "Hide all layers" : "Show all layers"}>{isShowAllLayers ? <LuEye size={20} color="MenuText" /> : <LuEyeOff size={20} color="MenuText" />}</Tooltip>
          </Button>

          <Button
            display="contents"
            background="transparent"
            p={0}
            onClick={() => {
              setIsAZ(!isAZ);
            }}
          >
            {isAZ ? <LuArrowDownAZ size={20} color="MenuText" /> : <LuArrowUpAZ size={20} color="MenuText" />}
          </Button>
        </HStack>
      </HStack>
      <SelectProject state={[showSelectProjectDialog, setShowSelectProjectDialog]} />
    </>
  );
};

export default LayerSortAndSearchBar;
